
"use client";

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from '@/components/ui/button';

export default function AgeGate() {
    const [showAgeGate, setShowAgeGate] = useState(false);
    const [user, setUser] = useState<User | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const router = useRouter();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (isLoading) return; // Don't run logic until auth state is known

        if (!user) {
            // User is logged out, always show the gate
            const isVerified = localStorage.getItem('ageVerified');
             if (isVerified !== 'true') {
                setShowAgeGate(true);
            }
        } else {
            // User is logged in, check localStorage
            const isVerified = localStorage.getItem('ageVerified');
            if (isVerified !== 'true') {
                setShowAgeGate(true);
            }
        }
    }, [user, isLoading]);

    const handleConfirm = () => {
        localStorage.setItem('ageVerified', 'true');
        setShowAgeGate(false);
        if (!user) {
            router.push('/login');
        }
    };

    const handleDecline = () => {
        window.location.href = 'https://www.google.com';
    };

    if (!showAgeGate) {
        return null;
    }

    return (
        <AlertDialog open={showAgeGate}>
            <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>Verificação de Idade</AlertDialogTitle>
                <AlertDialogDescription>
                Área Destinada a Membros!<br></br>
                Este site vende produtos destinados apenas a maiores de 18 anos. Você confirma que tem idade legal para comprar estes produtos?
                </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <Button variant="outline" onClick={handleDecline}>Não, sou menor</Button>
                <AlertDialogAction onClick={handleConfirm}>Confirmar Maioridade</AlertDialogAction>
            </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}
